// Debug logging that is silenced in production builds.
export const debugLog: (...args: unknown[]) => void = import.meta.env.DEV
  ? console.log.bind(console)
  : () => {};
